import { GoogleMap } from './GoogleMap/GoogleMap';
import { HereMap } from './HereMap/HereMap';

import { ContainerRef, Map } from './types';
import { MapName } from 'entities/map';

import {
  checkIsGoogleMap,
  checkIsHereMap
} from 'entities/map';

export const mapFactory = (mapName: MapName, containerRef: ContainerRef): Map => {
  if (checkIsGoogleMap(mapName)) {
    return new GoogleMap(containerRef);
  }

  if (checkIsHereMap(mapName)) {
    return new HereMap(containerRef);
  }

  throw Error('There is no such a map');
};
